import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { FormRow } from "../../../../components/ControlledInputs/styles";
import ControlledInput from "../../../../components/ControlledInputs/input";
import { FormattedMessage } from "react-intl";
import Button from "../../../InformaAcademy/components/button";
import { BiPlus } from "react-icons/bi";
import { Form } from "./styles";

const schema = z.object({
  order: z.coerce.number().optional(),
  chapterTitle: z.string().min(1).max(150, {
    message: "error.max_length-150",
  }),
});

export default function ChapterForm({
  chapters,
  setChapters,
  hideFormTitle = false,
}) {
  const form = useForm({
    resolver: zodResolver(schema),
  });

  const { control, handleSubmit, formState, reset } = form;

  const onSubmit = async (data) => {
    const reorderedChapters = reorderArray({
      array: [...chapters],
      newItem: {
        chapterTitle: data.chapterTitle,
        order: order({
          array: chapters,
          order: data.order,
        }),
      },
    });

    setChapters([...reorderedChapters]);
    reset();
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} key={Math.random()}>
      {!hideFormTitle && (
        <p>
          <FormattedMessage id={"manual_chapters"} />
        </p>
      )}
      <FormRow manual>
        <ControlledInput
          name={"chapterTitle"}
          max={150}
          control={control}
          formState={formState}
          label={"manual_chapter_title"}
          required={true}
          description={"course_name_sub"}
        />
        <ControlledInput
          name={"order"}
          control={control}
          formState={formState}
          label={"lesson_order"}
          inputMode="numeric"
          min={1}
          width={"200px"}
        />
        <Button
          label={"add"}
          Icon={<BiPlus size={16} />}
          variant={"secondary"}
        />
      </FormRow>
    </Form>
  );
}

export function reorderArray({ newItem, array }) {
  const copiedItem = {
    ...newItem,
    order: newItem.order > array.length + 1 ? array.length + 1 : newItem.order,
  };

  const firstPart = array
    .filter((_, index) => index <= newItem.order - 2)
    .map((i, ii) => ({ ...i, order: ii + 1 }));
  const secondPart = array
    .filter((_, index) => index > newItem.order - 2)
    .map((i, ii) => ({ ...i, order: ii + 1 + newItem.order }));

  console.log({
    firstPart,
    secondPart,
    copiedItem,
    newArray: [...firstPart, copiedItem, ...secondPart],
  });

  return [...firstPart, copiedItem, ...secondPart];
}

export function order({ order, array, key = "order" }) {
  return (
    order || (array.length > 0 ? Math.max(...array.map((i) => i[key])) + 1 : 1)
  );
}
